import { graphql, StaticQuery } from "gatsby";
import Img from "gatsby-image";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import Header from "../components/header";
import Icon from "../components/Icons";
import Navbar from "../components/navbar";

const NavLink = ({ text, to, blank, icon, active }) => (
	<a
		href={to}
		className="2 flex-1 flex flex-col items-center py-2 no-underline text-primary hover:bg-grey-light hover:text-primary-dark hover:font-semibold"
		target={blank ? "_blank" : null}
		rel="noopener noreferrer"
	>
		<Icon name={icon} active={active} />
		<span className={`text-xs ${active ? "font-semibold" : ""}`} style={{ marginTop: "5px" }}>
			{text}
		</span>
	</a>
);

NavLink.propTypes = {
	text: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
	icon: PropTypes.string.isRequired,
	blank: PropTypes.bool,
	active: PropTypes.bool,
};

NavLink.defaultProps = {
	blank: false,
	active: false,
};

const footerHeading = {
	fontFamily: "var(--heading-font)",
	fontSize: 13,
	fontWeight: 700,
	letterSpacing: "0.06em",
	textTransform: "uppercase",
	color: "var(--text)",
	margin: "0 0 16px",
};

const footerLinkStyle = { color: "var(--text-muted)", textDecoration: "none" };

const FooterHeading = ({ text }) => <h4 style={footerHeading}>{text}</h4>;

FooterHeading.propTypes = {
	text: PropTypes.string.isRequired,
};

function Layout({ children }) {
	const year = new Date().getFullYear();
	const address = `Hollywood Specialist Centre Suite 10/11 95 Monash Ave. Nedlands WA 6009 `.replace(/\s/g, "+");
	return (
		<StaticQuery
			query={graphql`
			query {
				site: site {
					siteMetadata {
						title
					}
				}
				logo: file(relativePath: { eq: "advanced-gi-logo.png" }) {
					childImageSharp {
						fluid(maxWidth: 700, quality: 100) {
							...GatsbyImageSharpFluid_withWebp
						}
					}
				}
			}
		`}

			render={({ logo, site }) => (
				<>
					<div style={{ background: "var(--bg)" }} className="flex flex-col font-sans min-h-screen text-grey-darkest">
						{/* <Link to="/articles/covid-19-planning" className="no-underline">
							<div className="w-full text-white bg-red-dark hover:font-semibold top-0 z-50 bg-white border-b border-primary p-4 text-center">
								IMPORTANT: Information about coronavirus (COVID-19), please click here and read prior to your
								appointment.							</div>
						</Link> */}
						<Header siteTitle={site.siteMetadata.title} logo={<Img fluid={logo.childImageSharp.fluid} />} />
						<Navbar />
						<div className="flex flex-col flex-1 max-w-main w-full mx-auto mb-16 px-12 pb-8 tracking-wide leading-normal">
							{children}
						</div>
						<footer
							className="section-pad"
							style={{ background: "var(--bg)", padding: "64px 48px 32px", marginTop: "auto" }}
						>
							<div
								className="footer-grid"
								style={{
									maxWidth: 1344,
									margin: "0 auto",
									display: "grid",
									gridTemplateColumns: "1.4fr 1fr 1fr 1fr",
									gap: 40,
									paddingBottom: 40,
								}}
							>
								<div>
									<div style={{ width: 200, marginBottom: 16 }}>
										<Img fluid={logo.childImageSharp.fluid} alt="Advanced GI WA" />
									</div>
									<p style={{ fontFamily: "var(--body-font)", fontSize: 13.5, lineHeight: 1.6, color: "var(--text-muted)", margin: 0 }}>
										Hollywood Specialist Centre
										<br />
										Suite 10/11, 95 Monash Ave
										<br />
										Nedlands WA 6009
									</p>
								</div>
								<div>
									<FooterHeading text="Contact" />
									<p style={{ fontFamily: "var(--body-font)", fontSize: 13.5, lineHeight: 2, color: "var(--text-muted)", margin: 0 }}>
										Phone: (08) 9389 1733
										<br />
										Fax: (08) 9389 1755
										<br />
										Email: info@advancedgiwa.com.au
										<br />
										Healthlink: advancgi
									</p>
								</div>
								<div>
									<FooterHeading text="Quick Links" />
									<p style={{ fontFamily: "var(--body-font)", fontSize: 13.5, lineHeight: 2, margin: 0 }}>
										<Link to="/" style={footerLinkStyle}>
											Home
										</Link>
										<br />
										<Link to="/our-team" style={footerLinkStyle}>
											Our Team
										</Link>
										<br />
										<Link to="/services" style={footerLinkStyle}>
											Services
										</Link>
										<br />
										<Link to="/contact" style={footerLinkStyle}>
											Contact
										</Link>
									</p>
								</div>
								<div>
									<FooterHeading text="Practice Info" />
									<p style={{ fontFamily: "var(--body-font)", fontSize: 13.5, lineHeight: 2, margin: 0 }}>
										<Link to="/patient-information" style={footerLinkStyle}>
											Patient Information
										</Link>
										<br />
										<Link to="/articles" style={footerLinkStyle}>
											Articles
										</Link>
										<br />
										<Link to="/Newsletters" style={footerLinkStyle}>
											Newsletters
										</Link>
									</p>
								</div>
							</div>
							<div style={{ maxWidth: 1344, margin: "0 auto", borderTop: "1px solid var(--border)", paddingTop: 24 }}>
								<p style={{ fontFamily: "var(--body-font)", fontSize: 12.5, color: "var(--text-muted)", margin: 0, textAlign: "center" }}>
									&copy; {year} Advanced GI WA Pty Ltd. All rights reserved.
								</p>
							</div>
						</footer>
						<footer className="md:hidden fixed bottom-0 bg-grey-lightest w-screen ">
							<nav className="flex border-t border-primary">
								<NavLink to="tel:0893891733" text="08 9389 1733" icon="phone" />
								<NavLink to="mailto:info@advancedgiwa.com.au" text="Email" icon="mail" />
								<NavLink to={`http://maps.google.com/?q=${address}`} text="Directions" blank icon="map" active />
							</nav>
						</footer>
					</div>
				</>
			)
			}
		/>
	);
}

Layout.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Layout;
